import { render, staticRenderFns } from "./FillAttrsItem.vue?vue&type=template&id=64512810&"
import script from "./FillAttrsItem.vue?vue&type=script&lang=js&"
export * from "./FillAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64512810')) {
      api.createRecord('64512810', component.options)
    } else {
      api.reload('64512810', component.options)
    }
    module.hot.accept("./FillAttrsItem.vue?vue&type=template&id=64512810&", function () {
      api.rerender('64512810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/items/FillAttrsItem.vue"
export default component.exports